export const HW_TILE_KEYS = {
  Biometry: "biometry",
  NoGas: "noGas",
  MultiDevice: "multiDevice",
  NoInstall: "noInstall",
}
